<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<!-- Referral abhi apply nahi kiya -->
<div class="pcard" *ngIf="!isLoading && !referralAvailable">
  <h2><i class="fa-solid fa-handshake"></i> Apply for Referral</h2>
  <p class="lead">
    Send a request to get your own referral code. Once it is approved your referrals and
    bonus amounts will show on the Bonus Amount tab.
  </p>
  <div class="actions">
    <button type="button" class="btn-pink" [disabled]="saving" (click)="saveChanges()">
      <i class="fa-solid fa-paper-plane"></i> {{ saving ? 'Sending...' : 'Send Request' }}
    </button>
  </div>
</div>

<!-- Referral code mil chuka hai -->
<ng-container *ngIf="!isLoading && referralAvailable">

  <div class="stats">
    <div class="stat">
      <i class="fa-solid fa-ticket"></i>
      <div>
        <small>Your Referral Code</small>
        <b>{{ userData?.Users?.refer_code }}</b>
      </div>
      <button type="button" class="copy" (click)="copyCode()" title="Copy code">
        <i class="fa-regular" [ngClass]="copied ? 'fa-circle-check' : 'fa-copy'"></i>
      </button>
    </div>
    <div class="stat">
      <i class="fa-solid fa-users"></i>
      <div>
        <small>Total Referrals</small>
        <b>{{ userData?.totalReffers || 0 }}</b>
      </div>
    </div>
  </div>

  <form class="pcard" (ngSubmit)="sendpaymentInfo()">
    <h2><i class="fa-solid fa-wallet"></i> Payment Info</h2>
    <div class="grid-2">
      <div class="fld">
        <label for="paymentId">Payment ID</label>
        <input type="text" id="paymentId" placeholder="Account ID" [(ngModel)]="paymentId" name="paymentId" autocomplete="off" />
      </div>
      <div class="fld">
        <label for="paymentType">Payment Type</label>
        <select id="paymentType" [(ngModel)]="paymentType" name="paymentType">
          <option value="" disabled>Please Select</option>
          <option value="Paypal">Paypal</option>
          <option value="Stripe">Stripe</option>
        </select>
      </div>
    </div>
    <div class="actions">
      <button type="submit" class="btn-pink" [disabled]="saving">
        <i class="fa-solid fa-floppy-disk"></i> {{ saving ? 'Saving...' : 'Send Payment Info' }}
      </button>
    </div>
  </form>

</ng-container>
